import moment from 'moment';
import zxcvbn from 'zxcvbn';
import _ from "lodash";
import formatCurrency from "format-currency";

class ChargecodeDetailsController {

  constructor(CompanyService, toastr, $scope, $http, $rootScope, $stateParams, $state, AuthenticationService) {
    "ngInject";

    let self = this;

    this.moment = moment;
    this.$http = $http;
    this.$rootScope = $rootScope;
    this.toastr = toastr;
    this.chargecode = {};
    this.state = $state;
    this.$stateParams = $stateParams;
    this.activeUsers = [];
    this.customers = [];
    this.auth = AuthenticationService;
    this.loadingChargeCode = true;

    this.payrollCostCategoryOptions = [
      { value: null, text: '(unset)' },
      { value: 'DIRECT', text: 'Direct' },
      { value: 'FRINGE', text: 'Fringe' },
      { value: 'OVERHEAD', text: 'Overhead' },
      { value: 'GENERAL_ADMINISTRATIVE', text: 'General & Administrative' },
      { value: 'BID_AND_PROPOSAL', text: 'B&P' }
    ];

    this.$http.get($rootScope.apiHost+"/api/admin/chargecodes/"+$stateParams.chargecodeId, {withCredentials: true}).then(function (success) {
      self.chargecode = success.data;
      self.loadingChargeCode = false;
      self.loadData();
    });
  }

  validateDataChange(parameter, value) {
    return !angular.equals(this.chargecode[parameter], value)
  }

  checkXEditPermission(permission) {
    let result = false;

    if(this.auth.hasPermission(permission)){
      result = true;
    }

    return result;
  }

  currency(value) {
    return '$' + formatCurrency(value);
  }

  getPayrollCostCategoryLabel(value) {
    let match = _.find(this.payrollCostCategoryOptions, { value: value });

    if (match) {
      return match.text;
    }

    return value;
  }

  loadData() {
    let self = this;

    // this.$http.get(self.$rootScope.apiHost+"/api/admin/customers", {withCredentials: true}).then(function (success) {
    //   self.customers = success.data;
    //
    //   if(self.chargecode.customer) {
    //     self.filteredContracts = self.chargecode.customer.contracts;
    //
    //     if(self.chargecode.contract) {
    //       self.filteredTasks = self.chargecode.contract.tasks;
    //       self.filteredLcats = self.chargecode.contract.laborCategories;
    //       self.filteredPops = self.chargecode.contract.periodsOfPerformance;
    //     }
    //   }
    // });

    this.$http.get(self.$rootScope.apiHost+'/api/admin/users/names?active=true', {withCredentials: true}).then(function (success) {
      self.activeUsers = success.data;
    });

    if(this.chargecode.subkFlag) {
      this.activeSubcontractEmployees = [];
      this.$http.get(self.$rootScope.apiHost + '/api/admin/subcontractors/' + this.chargecode.subcontract.subcontractorId + "/employees", {withCredentials: true}).then(function (success) {
        self.activeSubcontractEmployees = success.data;
      });
    }


      this.$http.get(this.$rootScope.apiHost+"/api/admin/chargecodes/"+this.$stateParams.chargecodeId+"/users", {withCredentials: true}).then(function (success) {
        self.chargecode.users = success.data;
      });

      if (this.chargecode.expirationDate) {
        this.chargecode.expirationDate = Date.parse(this.chargecode.expirationDate+"");
      }

      if (this.chargecode.effectiveDate) {
        this.chargecode.effectiveDate = Date.parse(this.chargecode.effectiveDate+"");
      }

      self.chargecode.revenue = (self.chargecode.billedHours * self.chargecode.popRate.rate).toFixed(2);
  }

  userHasChargeCode(userId) {
    let x = _.find(this.chargecode.users, {'id': userId} );
    return x ? true : false;
  }

  selectCustomer() {
    if(this.chargecode.customer) {
      this.filteredContracts = this.chargecode.customer.contracts;
    } else {
      this.filteredContracts = undefined;
      this.filteredLcats = undefined;
      this.filteredPops = undefined;
      this.filteredTasks = undefined;
    }
  }

  selectContract() {
    if(this.chargecode.contract) {
      this.filteredLcats = this.chargecode.contract.laborCategories;
      this.filteredPops = this.chargecode.contract.periodsOfPerformance;
      this.filteredTasks = this.chargecode.contract.tasks;
    } else {
      this.filteredLcats = undefined;
      this.filteredPops = undefined;
      this.filteredTasks = undefined;
    }
  }

  addUserToChargeCode(user) {
    this.$http.post(this.$rootScope.apiHost+"/api/admin/chargecodes/"+this.chargecode.id+"/users/"+user.id, {}, {withCredentials: true}).then(success => {
      this.chargecode.users = success.data;
      this.toastr.success('User Added To Charge Code.');
    }, failure => {
      this.toastr.error('Could not add user to charge code', 'ERROR');
    });

    this.selectedUser = undefined;
  }

  removeUserFromChargeCode(user) {
    this.$http.delete(this.$rootScope.apiHost+"/api/admin/chargecodes/"+this.chargecode.id+"/users/"+user.id, {withCredentials: true}).then(success => {
      this.chargecode.users = success.data;
      this.toastr.success('User Removed from Charge Code.');
    }, failure => {
      this.toastr.error('Could not add user to charge code', 'ERROR');
    });

    this.activeUsers.push(user);
  }

  deleteChargeCode() {
    this.$http.delete(this.$rootScope.apiHost+"/api/admin/chargecodes/"+this.chargecode.id, {withCredentials: true}).then(success => {
      this.toastr.success('Charge Code Has Been Deleted');
      this.state.go('admin.chargecodes');
    }, failure => {
      this.toastr.error('Could not delete charge code', 'ERROR');
    });
  }

  updateChargeCodeCustomer(chargecodeId, customer) {
    let obj = {
      customer: customer,
      contract: null,
      taskOrder: null,
      laborCategory: null,
      periodOfPerformance: null
    };

    this.$http.patch(this.$rootScope.apiHost+"/api/admin/chargecodes/"+chargecodeId, obj, {withCredentials: true}).then(success => {
      this.chargecode = success.data;
      this.loadData();
      this.toastr.success('The Charge Code has been updated.');
    }, failure => {
      this.toastr.error('Could not update '+parameter, 'ERROR');
    });
  }

  updateChargeCodeContract(chargecodeId, contract) {
    let obj = {
      contract: contract,
      taskOrder: null,
      laborCategory: null,
      periodOfPerformance: null
    };

    this.$http.patch(this.$rootScope.apiHost+"/api/admin/chargecodes/"+chargecodeId, obj, {withCredentials: true}).then(success => {
      this.chargecode = success.data;
      this.loadData();
      this.toastr.success('The Charge Code has been updated.');
    }, failure => {
      this.toastr.error('Could not update '+parameter, 'ERROR');
    });
  }

  updateChargeCodeDetails(id, parameter, value) {
    let obj = {};
    obj[parameter] = value;

    this.$http.patch(this.$rootScope.apiHost+"/api/admin/chargecodes/"+id, obj, {withCredentials: true}).then(success => {
      this.chargecode = success.data;
      this.loadData();
      this.toastr.success('The Charge Code has been updated.');
    }, failure => {
      this.toastr.error('Could not update '+parameter, 'ERROR');
    });
  }


}

export default ChargecodeDetailsController;



// WEBPACK FOOTER //
// ./client/pages/admin/chargecode-details/chargecode-details.controller.js